import fetchApi from '../../Services/requests';
import { EditProfileUrl, ProfileDataUrl } from '../../Routes/profile.route';

export const getProfileDataAction = async (set, clubBranchId: number) => {
  set({ profileData: null, profileLoading: true, profileError: false });

  const response = await fetchApi(ProfileDataUrl(), { clubBranchId });

  response?.ok
    ? set({
        profileData: response.data,
        profileLoading: false,
        profileError: false
      })
    : set({ profileData: null, profileLoading: false, profileError: true });
  return response?.ok;
};

export const editProfileDataAction = async (
  set,
  body: {
    clubBranchId: number;
    name?: string;
    sex?: string;
    email?: string;
    birthday?: string;
  }
): Promise<boolean> => {
  set({ editProfileLoading: true, editProfileError: false });

  const response = await fetchApi(EditProfileUrl(), body);

  response?.ok
    ? set((state) => ({
        editProfileLoading: false,
        editProfileError: false,
        profileData: { ...state.profileData, ...body }
      }))
    : set({ editProfileLoading: true, editProfileError: false });
  return response.ok;
};
